import type { ReactNode } from 'react'
import { Box, Text } from '@n26/nxd'

type ErrorMessageProps = {
  id?: string
  children: ReactNode
}

export const ErrorMessage = ({ id, children }: ErrorMessageProps) => (
  <Box
    id={id}
    role='alert'
    padding='12'
    borderRadius='8'
    backgroundColor='rhubarb-alternate'
  >
    <Text variant='small' color='rhubarb'>
      {children}
    </Text>
  </Box>
)
